{
  "Accessibility Menu": "Accessibility Menu",
  "Reset settings": "Astellungen zrécksetzen",
  "Close": "Zoumaachen",
  "Content Adjustments": "Inhalt Unpassungen",
  "Adjust Font Size": "Schrëftgréisst unpassen",
  "Highlight Title": "Titel markéieren",
  "Highlight Links": "Links markéieren",
  "Readable Font": "Liesbar Schrëft",
  "Color Adjustments": "Faarfleg Unpassungen",
  "Dark Contrast": "Däischteren Kontrast",
  "Light Contrast": "Hellen Kontrast",
  "High Contrast": "Héijen Kontrast",
  "High Saturation": "Héij Sättigung",
  "Low Saturation": "Niddrég Sättigung",
  "Monochrome": "Monochrom",
  "Tools": "Tools",
  "Reading Guide": "Guide fir ze liesen",
  "Stop Animations": "Animatiounen stoppen",
  "Big Cursor": "Groussen Cursor",
  "Increase Font Size": "Schrëftgréisst erhéijen",
  "Decrease Font Size": "Schrëftgréisst ernidderegen",
  "Letter Spacing": "Zeechenofstand",
  "Line Height": "Linn Héicht",
  "Font Weight": "Schrëftgewiicht",
  "Dyslexia Font": "Schrëft fir Dyslexie",
  "Language": "Sprooch",
  "Open Accessibility Menu": "Accessibility Menu opmaachen",
  "Accessibility Profiles": "Accessibilitéitsprofiler",
  "Seizure Safe Profile": "Anfall-sécher Profil",
  "Stops animations and reduces color saturation.": "Stoppt Animatiounen an reduzéiert d'Faarfsättigung.",
  "Blind Profile": "Blann Profil",
  "Activates the screen reader for auditory navigation.": "Aktivéiert de Screen Reader fir auditiv Navigation.",
  "Visually Impaired Profile": "Visuell beaflosst Profil",
  "Enhances contrast and readability for low vision.": "Verbessert Kontrast an Liesbarkeet fir niddreg Visibilitéit.",
  "ADHD Friendly Profile": "ADHD-frëndlecht Profil",
  "Reduces distractions for better focus.": "Reduzéiert Stéierungen fir besser Konzentratioun.",
  "Cognitive & Learning Profile": "Kognitiv & Léierprofil",
  "Helpful tools for reading and comprehension.": "Hëllefräich Tools fir Liesung a Versteesdemech.",
  "Motor Impaired Profile": "Motorisch beaflosst Profil",
  "Optimizes the site for keyboard-only navigation.": "Optiméiert d'Säit fir nëmme Tastatur-Navigatioun.",
  "Headings": "Iwwerschrëften",
  "Landmarks": "Landmarken",
  "Links": "Linken",
  "Focus element": "Fokus-Element",
  "Visit link": "Link besichen"
}